import styles from "./RightSidebar.module.scss";
import { GlyphClose } from "@aurora/icons";
import React, { FC, useRef, useState } from "react";

interface Props {
  children?: React.ReactNode | React.ReactNode[];
  onClose: () => void;
  show: boolean;
  widthPercent?: number;
}

const RightSidebar: FC<Props> = ({ children, onClose, show, widthPercent }) => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const [isClosing, changeClose] = useState(false);
  const styleWidth = () => {
    if (!widthPercent) {
      return { left: {}, right: {} };
    }
    return {
      left: { width: `${100 - widthPercent}%` },
      right: { width: `${widthPercent}%` },
    };
  };
  return (
    <div
      className={`${styles.RightSidebarWrapper} ${
        show && !isClosing ? styles.show : ""
      }`}
    >
      <div
        className={styles.LeftSideWrapper}
        onClick={() => {
          changeClose(true);
          setTimeout(() => {
            onClose();
            changeClose(false);
          }, 300);
        }}
        style={styleWidth().left}
      >
        <div
          className={`${styles.LeftSideWrapperClose} ${
            show && !isClosing ? styles.LeftSideWrapperCloseOpen : ""
          }`}
          title="Закрыть"
        >
          <GlyphClose />
        </div>

        <div id="RightSideBarFilterBlock"></div>
      </div>

      <div
        ref={sidebarRef}
        className={styles.RightSidebar}
        style={styleWidth().right}
      >
        <div className={styles.RightSidebarChildren}>{children}</div>
      </div>
    </div>
  );
};

export default RightSidebar;
